// Design-only mode: live API base URL is disabled for now.

//UAT
//export const Base_Url = "https://api.eleecontrol.mkisan.com/";

// Production
export const Base_Url = "https://api.eleecontrols.com/";

// export const Base_Url = "";
